import script from "./wxLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./wxLogin.vue?vue&type=script&setup=true&lang=ts"

import "./wxLogin.vue?vue&type=style&index=0&id=4fc7a906&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc7a906"]])

export default __exports__